class RegistrationBuilder {
  setFirstName(firstName) {
    this.firstName = firstName;
    return this;
  }
  setLastName(lastName) {
    this.lastName = lastName;
    return this;
  }
  setPassword(password) {
    this.password = password;
    return this;
  }
  setEmail(email) {
    this.email = email;
    return this;
  }
  setDateOfBirth(dateOfBirth) {
    this.dateOfBirth = this.convertIfStrDate(dateOfBirth);
    return this;
  }
  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
    return this;
  }
  setZipCode(zipCode) {
    this.zipCode = zipCode;
    return this;
  }
  setMedicalId(medicalId) {
    this.medicalId = medicalId;
    return this;
  }
  setMedicalIdNumber(medicalIdNumber) {
    this.medicalIdNumber = medicalIdNumber;
    return this;
  }
  setMedicalIdExpirationDate(date) {
    this.medicalIdExpirationDate = this.convertIfStrDate(date);
    return this;
  }
  setMedicalIdState(state) {
    this.medicalIdState = typeof state === "string" ? state.toUpperCase() : state;
    return this;
  }
  setSelfieId(selfieId) {
    this.selfieId = selfieId;
    return this;
  }
  setIdentityDocument(identityDocument) {
    this.identityDocument = identityDocument;
    return this;
  }
  setMarketingSource(marketingSource) {
    this.marketingSource = marketingSource;
    return this;
  }

  setMarketingEmailOptIn(marketingEmailOptIn) {
    this.marketingEmailOptIn = marketingEmailOptIn;
    return this;
  }

  setMarketingSmsOptIn(marketingSmsOptIn) {
    this.marketingSmsOptIn = marketingSmsOptIn;
    return this;
  }

  setStateResidency(stateResidency) {
    this.stateResidency = stateResidency;
    return this;
  }

  setDriversLicenseIdExpirationDate(date) {
    this.driversLicenseIdExpirationDate = this.convertIfStrDate(date);
    return this;
  }

  setDriversLicenseIdNumber(driversLicenseIdNumber) {
    this.driversLicenseIdNumber = driversLicenseIdNumber;
    return this;
  }

  build() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      password: this.password,
      email: this.email,
      phoneNumber: this.phoneNumber,
      dateOfBirth: this.dateOfBirth,
      zipCode: this.zipCode,
      medicalId: this.medicalId,
      identityDocument: this.identityDocument,
      medicalIdNumber: this.medicalIdNumber,
      medicalIdExpirationDate: this.medicalIdExpirationDate,
      medicalIdState: this.medicalIdState,
      selfieId: this.selfieId,
      marketingSource: this.marketingSource,
      marketingEmailOptIn: this.marketingEmailOptIn,
      marketingSmsOptIn: this.marketingSmsOptIn,
      stateResidency: this.stateResidency,
      driversLicenseIdNumber: this.driversLicenseIdNumber,
      driversLicenseIdExpirationDate: this.driversLicenseIdExpirationDate,
    };
  }

  convertIfStrDate = (date) => {
    return typeof date === "string" ? new Date(date) : date;
  };
}

export default RegistrationBuilder;
